import { TicketConfirmationComponent } from 'src/app/component/ticket-confirmation/ticket-confirmation.component';
import { WalletPayComponent } from 'src/app/component/wallet-pay/wallet-pay.component';
import { ApiService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';
import { LoadingService } from 'src/app/services/loading.service';

import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, NavController } from '@ionic/angular';
import { OrderResponseBody } from '@paypal/paypal-js';
import { User } from '@shared/models';
import { PaymentMethod } from '@shared/models/payment.model';
import { VendorsStore } from '@shared/stores';

import { TicketSwapComponent } from '../../../component/ticket-swap/ticket-swap.component';

@Component({
  selector: 'app-ticket-summary',
  templateUrl: './ticket-summary.page.html',
  styleUrls: ['./ticket-summary.page.scss'],
})
export class TicketSummaryPage implements OnInit {
  vendorsStore = inject(VendorsStore);
  amount: number = 0;
  user: User | null = null;
  subscription: any | null = null;
  ticket: any | null = null;
  balance: number = 0;

  constructor(
    private modalCtrl: ModalController,
    private navController: NavController,
    private dataService: DataService,
    private navCtrl: NavController,
    private authService: AuthService,
    private apiService: ApiService,
    private loadingService: LoadingService,
    private router: Router
  ) {}

  ngOnInit() {
    this.ticket = this.dataService.getData('ticket-summary');
    if (!this.ticket) {
      this.navCtrl.navigateBack('/tecservice-transportec/transportec/tickets');
    } else {
      if (typeof this.ticket.trip.amount !== 'undefined') {
        this.amount = this.ticket.trip.amount;
      }
      this.getUser();
      this.getBalance();
      this.getSuscription();
      this.unsetData();
    }
  }

  ionViewWillEnter() {
    this.vendorsStore.vendorsQuery.refetch();
  }

  unsetData() {
    this.dataService.setData('payment-amount', null);
    this.dataService.setData('subscription-selection', null);
    this.dataService.setData('subscription-radial', null);
    this.dataService.setData('busticket-item', null);
  }

  getUser() {
    this.authService.getUser().then((user) => {
      this.user = user;
    });
  }

  getBalance() {
    this.authService.getBalance().then((balance) => {
      this.balance = balance.balance;
    });
  }

  getSuscription() {
    this.authService
      .get(
        'suscription?check=' +
          this.ticket.search.type +
          '&date=' +
          this.ticket.search.date +
          '&dotw=' +
          new Date(this.ticket.search.date).getDay() +
          '&route_id=' +
          this.ticket.search.stop.route_id +
          '&stop_id=' +
          this.ticket.search.stop.id +
          '&radial_id=' +
          this.ticket.search.stop.radial_id
      )
      .then((res) => {
        this.subscription = res.data;
      })
      .catch((err) => {
        console.error('Error getting suscription: ', err);
      });
  }

  goWallet() {
    this.modalCtrl
      .create({
        component: WalletPayComponent,
        componentProps: { amount: this.amount },
      })
      .then((modal) => {
        modal.present();
        modal.onDidDismiss().then((res) => {
          if (res.data && res.data.pay) {
            this.pay('wallet');
          }
        });
      });
  }

  pay(paymentMethod = 'wallet', extraParams: Record<string, any> = {}) {
    this.loadingService.present();
    this.apiService
      .postData('bustickets', {
        method: paymentMethod,
        amount: this.amount,
        bus_id: this.ticket.trip.bus_id,
        realtrip_id: this.ticket.trip.id,
        stop_id: this.ticket.search.stop.id,
        starts_at: this.ticket.trip.starts_at,
        date: this.ticket.search.date,
        ...extraParams,
      })
      .then((res) => {
        if (res.success) {
          this.goTicket(res.busticket);
        } else {
          this.authService.presentToast('Ocurrió un error favor de intentarlo más tarde.');
        }
      })
      .catch((err) => {
        console.error('Error: ', err);
        this.authService.presentToast('Ocurrió un error favor de intentarlo más tarde.');
      })
      .finally(() => {
        this.loadingService.dismiss();
      });
  }

  goPay(method: PaymentMethod) {
    this.dataService.setData('busticket-item', { ticket: this.ticket, price: this.amount });
    if (method === 'credit_card') {
      this.router.navigate(['tecservice-transportec/transportec/ticket-summary/payment-card']);
    } else if (method === 'credit_card_openpay') {
      this.router.navigate(['tecservice-transportec/transportec/ticket-summary/payment-card-openpay']);
    } else if (method === 'credit_card_paycode') {
      this.router.navigate(['tecservice-transportec/transportec/ticket-summary/payment-card-paycode']);
    }
  }

  goSwap() {
    this.modalCtrl
      .create({
        component: TicketSwapComponent,
        componentProps: { ticket: this.ticket },
      })
      .then((modal) => {
        modal.present();
        modal.onDidDismiss().then((res) => {
          if (res.data && res.data.pay) {
            this.pay('swap');
          }
        });
      });
  }

  goTicket(ticket: any) {
    if (ticket) {
      this.modalCtrl
        .create({
          component: TicketConfirmationComponent,
          componentProps: { amount: this.amount },
        })
        .then((modal) => {
          modal.present();
          modal.onDidDismiss().then((res) => {
            this.dataService.setData(ticket.id, ticket);
            this.navController.navigateRoot(['/tecservice-transportec/tickets/ticket/', ticket.id]);
          });
        });
    }
  }

  onPayPalSuccess(order: OrderResponseBody) {
    this.pay('paypal', { token_paypal: order.id });
  }

  onPayPalError(error: string) {
    this.authService.presentToast(error);
    this.vendorsStore.vendorsQuery.refetch();
  }
}
